<template>
  <div style="display: flex; color: #606266; align-items: center; font-size: 14px; margin-bottom: 22px;">
    <div style="width: 100px; text-align: right; padding-right: 12px; box-sizing: border-box">选择时间</div>
    <div>
      <DateGroup :start="start" :end="end" @onDatePicker="onDatePicker" />
    </div>
    <div style="width: 280px; padding-left: 10px;">
      <DatePicker :start="start" :end="end" @onDatePicker="onDatePicker" />
    </div>
    <slot></slot>
  </div>
</template>

<script>
import DateGroup from './dateGroup'
import DatePicker from './datePicker'
export default {
  components: {
    DatePicker,
    DateGroup
  },
  props: {
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    },
    onDatePicker: {
      type: Function
    }
  }
}
</script>
